import { SectionHead, Reveal } from "./Reveal";
import { useLang } from "../../i18n/LanguageContext";

export const FieldStrip = () => {
  const { t } = useLang();
  return (
    <section className="relative bg-ink bp-grid-dark py-20 sm:py-28 overflow-hidden" data-testid="field-section">
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8">
        <SectionHead dark eyebrow={t.field.eyebrow} title={t.field.title} desc={t.field.desc} testid="field" />
      </div>
      <div className="mt-12 overflow-x-auto pb-4 [scrollbar-width:thin]">
        <div className="flex gap-5 px-5 sm:px-8 w-max">
          {t.field.items.map((f, i) => (
            <Reveal key={f.img} delay={i * 0.07}>
              <figure
                data-testid={`field-photo-${i}`}
                className="chamfer group relative w-[300px] sm:w-[360px] shrink-0 border border-[#f8f7f4]/15 bg-[#1d2024]"
              >
                <div className="h-56 sm:h-64 overflow-hidden">
                  <img
                    src={f.img}
                    alt={f.cap}
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.05]"
                  />
                </div>
                <figcaption className="flex items-center justify-between gap-3 border-t border-[#f8f7f4]/15 px-4 py-3">
                  <span className="font-mono-tech text-[10px] uppercase tracking-[0.15em] text-[#f8f7f4]/70">{f.cap}</span>
                  <span className="font-mono-tech text-[10px] text-[#e63946]">{String(i + 1).padStart(2, "0")}</span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
